import styled from "styled-components";

/**
 * Table body component
 * Ready to use with Table component
 */
export const TBody = styled.tbody`
    font-size: 1.4rem;
`;
